<template>
    <div class = "card">
      <i class = "rating" v-if = "schedule.rating > 0" > ☆ {{schedule.rating}} </i>
      <h3> {{schedule.title}} </h3>
      <p>
        {{schedule.synopsis}}
      </p>
      <a :href = schedule.link>
        <button>MAL</button>
      </a>
    </div>
</template>

<script>
export default {
  name: 'ScheduledSeries',
  props: {
    schedule: Object
  }
}
</script>
